export const CONSTANTS = {
    CONTAINER_SIZE: 248,
    DEFAULT_CROP_WIDTH: 2000,
    DEFAULT_CROP_HEIGHT: 1500,
    MAX_IMAGE_FILE_SIZE: 2 * 1024 * 1024,
    MAX_VIDEO_FILE_SIZE: 5 * 1024 * 1024,
    VIDEO_PROCESSING_API: "https://backend.mckp.live/process-video",

    ZOOM: {
        MIN: 100,
        MAX: 400,
        DEFAULT: 100,
        STEP: 1,
    },

    TILE_ZOOM: {
        MIN: 5,
        MAX: 200,
        DEFAULT: 100,
        STEP: 1,
    },

    EDITOR_MODES: {
        CROP: "crop",
        TILE: "tile",
    },
} as const
